import { render, staticRenderFns } from "./KPISLA.vue?vue&type=template&id=360a19a7&"
import script from "./KPISLA.vue?vue&type=script&lang=js&"
export * from "./KPISLA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports